import * as React from "react";
import { pure } from "recompose";
// import * as cx from "classnames";
import * as i18next from "i18next";
import BoxGrid from "@tunnel-components/@sharded/widgets/box/custom/component";
import TextInput from "@tunnel-components/@sharded/widgets/forms/input/text/normal/component";
import * as cx from "classnames";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    onSubmit,
    item,
    disabled,
    extractionVideoBoolean,
    onChangeVideoRules,
    rulesVideo,
  } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */

  return (
    <li className="homeDisplay">
      <BoxGrid
        title={i18next.t("EXTRACTION VIDÉO")}
        classNames="boderShadow"
        error={!disabled}
        onSubmit={onSubmit}
        BtnTextSpan={i18next.t("enregistrer")}
      >
        <div className="boxGridContentInsider">
          {item &&
            item.map((elem: any, index: number) => {
              return (
                <div className="boxGridContentText" key={index}>
                  <div className="left boxGridTextText">
                    <span>{i18next.t(`${elem.name}`)} :</span>
                  </div>
                  <div
                    className={cx("left boxGridTextText", {
                      inputError: index === 2 && extractionVideoBoolean,
                    })}
                  >
                    <TextInput
                      maxLength={elem.max}
                      disabled={!disabled}
                      value={rulesVideo[index].value}
                      onChangeValue={onChangeVideoRules(index, elem.id)}
                      autoComplete="off"
                      autoFocus={true}
                    />
                    <span> {i18next.t("secondes")}</span>
                  </div>
                </div>
              );
            })}
        </div>
      </BoxGrid>
    </li>
  );
};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  onSubmit?: any;
  disabled?: any;
  item?: any;
  onChangeVideoRules?: any;
  rulesVideo?: any;
  extractionVideoBoolean?: any;
}
export default pure(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/display/video/component.tsx